export enum AddToCartEventSource {
  DASHBOARD_ADD = 'DASHBOARD',
  LIABILITY_DETAILS = 'LIABILITY_DETAILS',
  URGENT_ADD = 'URGENT-HEADER-SELECTED',
  URGENT_ADD_ALL = 'URGENT-HEADER-ALL',
  URGENT_EXPANDABLE_MENU = 'URGENT-EXPANDABLE_MENU',
  LIABILITIES = 'LIABILITIES-ADD-SELECTED',
  LIABILITIES_ALL_ADD = 'LIABILITIES-HEADER-SELECTED',
  LIABILITIES_ALL_ADD_ALL = 'LIABILITIES-HEADER-ALL',
  LIABILITIES_ALL_EXPANDABLE_MENU = 'LIABILITIES-EXPANDABLE_MENU',
  CART_SUGGESTION = 'CART_SUGGESTION',
  SINGLE_PAYMENT = 'SINGLE_PAYMENT',
  ADD_TOP_UP = 'ADD_TOP_UP',
}
